import { OrgTypeEnum } from "@gap/backend/app-services/org/models/OrgTypeEnum";
import { useOrgGuardStore } from "features/main/main-router/org-guard/OrgGuardStore";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";

export default observer(function OnlyForOrgType(props: { orgType: OrgTypeEnum, children: React.ReactNode, and?: boolean }) {
   const orgGuardStore = useOrgGuardStore()

   const isTheRightOrgType = useMemo(() => {
      switch (orgGuardStore.org?.orgType) {
         case 'client':
            if (props.orgType === 'client') {
               return true
            }
            return false
         case 'advisor':
            if (props.orgType === 'advisor') {
               return true
            }
            return false
         case 'gap':
            if (props.orgType === 'gap') {
               return true
            }
            return false
         default:
            return false
      }
   }, [orgGuardStore.org?.orgType, props.orgType])

   if (isTheRightOrgType) {
      if ('and' in props) {
         return props.and ? props.children : null
      }
      return props.children
   }

   return null
})
